module.exports = {
  // Brand
  colorPrimary: '#0093EE',
  colorOrange: '#fe7a24',
  colorOrangeLight: '#ffad7e',

  // Semantic
  colorDanger: '#ff0000',
  colorError: '#ff7875',
  colorSuccess: '#92D050',
  colorWarning: '#faad14',
  colorInfo: '#00aff5',

  // Text
  colorText: '#010101',
  colorDarkText: '#5B6B7F',
  colorGreyText: '#8c8c8c',
  colorDarkGreyText: '#4E4E4E',

  // Backgrounds
  colorWhite: '#fefefe',
  colorBlack: '#121212',
  colorSuperBlack: '#000000',
  colorBackGrey: '#fafafa',
  colorPaleGray: '#f9f9f9',
  colorRowHover: '#FAFBFC',
  colorRowActive: '#EEF5FC',
  colorHoverBlue: '#ecf5fd',

  // Blue palette
  colorBlue: '#03B0F6',
  colorLightBlue: '#00aff5',
  colorDarkBlue: '#1b5366',
  colorIndigo: '#2c405a',
  colorDocumentBlue: '#a9c6e0',
  colorIconBlue: '#9bb5cb',

  // Grey palette
  colorGrey: '#c3c5cb',
  colorLightGrey: '#a6a6a6',
  colorGreySub: '#9ba6b4',
  colorGreyBorder: 'rgba(0,0,0,.26)',

  // Links
  colorLink: '#05B0F0',
  colorLinkDark: '#44546A',
  colorLinkText: '#2B587A',
  colorLinkHover: '#828993',

  // Borders
  colorBorder: '#f5f5f6',
  colorBorderLine: '#e8eaf1',
  colorBorderCard: 'rgba(229, 238, 245, 0.38)',
  colorDivider: '#d8e5ee',
  colorInputBorder: '#a8c6df',
  colorMenuBorder: '#dedfe2',

  // Form
  colorInputPlaceholder: '#C9C9C9',
  colorDisabled: '#C9C9C9',

  // Border radius
  borderRadius: '4px',
  borderRadiusNum: 4,

  // Typography
  fontFamilyBase: 'Open Sans,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial, sans-serif',
  fontFamilyHeader: 'PT Sans, Open Sans, Arial, sans-serif',
  fontSizeInput: '15px',

  // Spacing
  spacingXXS: '4px',
  spacingXS: '8px',
  spacingSS: '12px',
  spacingS: '15px',
  spacingSM: '20px',
  spacingM: '24px',
  spacingL: '32px',
  spacingXL: '64px',
  spacingXXL: '128px',
  spacingGap: '20px',

  // Effects
  shadow: '0 2px 10px 0 rgba(0, 0, 0, 0.03)',
  transitionTime: '0.2s',
  animTime: '0.5s',
}
